export interface IFirmwaresQueryParams {
  page?: number;
  perPage?: number;
  search?: string;
  type?: string;
  status?: string;
  sortBy?: string;
  sortDirection?: string;
}
